// 新聞目錄
'use client';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';

const ParagraphComponent = ({ title, index }) => {
    return (
        <a href={`#paragraph-${index}`} className="cp flex gap-x-[10px] items-start group">
            <Image
                className="flex-shrink-0 mt-[3px]"
                src="/images/icon/icon_paragraph.svg"
                width={9}
                height={9}
                alt="icon"
            />
            <p className="text-btn4 text-black1 hover-text group-hover:text-bou break-all group-hover:decoration-bou">
                {title}
            </p>
        </a>
    );
};

const NewsParagraph = ({ content }) => {
    const { t } = useTranslation();
    // 章節
    const [paragraph, setParagraph] = useState([]);

    // 處理章節
    const handleParagraph = () => {
        if (!content) return;

        // 使用正則表達式匹配 <h2> 標籤內的內容
        const matches = content.match(/<h2.*?>(.*?)<\/h2>/g);

        if (matches) {
            // 取出 <h2> 內的關鍵字
            const titles = matches.map((match) => match.replace(/<\/?.*?>/g, ''));
            setParagraph(titles);
        }
    };

    useEffect(() => {
        handleParagraph();
    }, [content]);

    if (paragraph?.length > 2)
        return (
            <div
                className="rounded-[12px] px-[38px] py-[30px] w-full border-1 border-dashed border-black8 mt-[45px] space-y-[20px]
                usm:px-[25px] usm:py-[30px]"
            >
                <p className="text-h3 text-bou flex -items-center gap-x-[10px]">
                    <span>{t('MENU')}</span>
                    <span style={{ fontFamily: 'Montserrat' }} className="text-[#FFDDF3] text-bd1n">
                        Contents
                    </span>
                </p>
                {paragraph?.map((title, i) => (
                    <ParagraphComponent key={title + i} title={title} index={i} />
                ))}
            </div>
        );
    return null;
};

export default NewsParagraph;
